// PR2 — server-assembled system prompt for local models (mirrors cloud /agent-turn brain).
//
// S3 F1 — POST so the LOCAL path threads the SAME steering + spec the cloud
// /agent-turn does. The server's buildSystemPrompt then enforces precedence
// ("projeto > modelo") + budget through the ONE assembler, so local matches
// cloud (steering/spec sit ABOVE brain/persona/memory, not below). With no
// steering and no spec the server is byte-identical to the old GET behavior.

import { apiFetch } from './api.js';

export async function fetchSessionSystemPrompt(sessionId, { steering = [], spec = null } = {}) {
  if (!sessionId) return '';
  try {
    const res = await apiFetch(`/api/code-ide/sessions/${sessionId}/system-prompt`, {
      method: 'POST',
      body: {
        steering: Array.isArray(steering) ? steering : [],
        spec: spec ?? null,
      },
    });
    if (res.ok && typeof res.data?.prompt === 'string') return res.data.prompt.trim();
    return '';
  } catch {
    return '';
  }
}
